<template>
  <add-or-edit-group
    v-if="addOrEditBox == true"
    :id="addOrEditId"
    :type="type"
    :status="1"
    :defaultData="defaultData"
    @goBack="goBack"
  ></add-or-edit-group>
  <div class="page_box" v-else>
    <!-- <JobStructure></JobStructure> -->
    <!-- 安全小组   报修小组 -->
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="openAddBox()"
          v-if="JSON.stringify(formData) == '{}'"
          >添加</el-button
        >
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-edit-outline"
          @click="openEditBox(formData)"
          v-if="JSON.stringify(formData) != '{}'"
        >
          编辑
        </el-button>
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="deleteListData(formData.securityTeamId)"
          v-if="JSON.stringify(formData) != '{}'"
        >
          删除
        </el-button>
      </div>
    </div>

    <div class="page_table_box">
      <div class="content-box">
        <div class="info-content">
          <el-form
            label-position="left"
            label-width="80px"
            :model="formData"
            class="demo-form-inline"
          >
            <el-form-item label="小组名称:">
              <el-tooltip
                class="item"
                effect="light"
                :content="formData.securityTeamName"
                placement="top"
              >
                <span>
                  {{ formData.securityTeamName }}
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="组长:">
              <el-tooltip
                class="item"
                effect="light"
                :content="formData.groupLeaderStr"
                placement="top"
              >
                <span>{{ formData.groupLeaderStr }}</span>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              :label="userInfo.eduBuresuType == -1 ? '处理人员:' : '后勤人员:'"
            >
              <el-tooltip
                class="item"
                effect="light"
                :content="formData.rearServicePersonnelStr"
                placement="top"
              >
                <!-- style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap" -->
                <span>{{ formData.rearServicePersonnelStr }}</span>
              </el-tooltip>
            </el-form-item>
            <!-- <el-form-item label="组员:">
                <el-input
                  type="textarea"
                  :rows="8"
                  placeholder="请输入内容"
                  v-model="formData.groupMemberStr"
                >
                </el-input>
              </el-form-item> -->
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobStructure from "@/components/JobStructure";
import AddOrEditGroup from "./components/AddOrEditGroup";
export default {
  name: "",
  components: { JobStructure, AddOrEditGroup },
  props: {},
  data() {
    return {
      selectTeTeacherDepartment: false,
      listBox: true,
      selectCate: 1, // 组长操作，2组员操作
      formData: {},
      // 请求参数
      requestParamsData: {
        schoolId: this.$store.state.schoolId,
        type: 1
      },
      addOrEditBox: false, //新增或修改
      addOrEditId: "", //修改id
      type: "add", //类型
      defaultData: {
        schoolId: this.$store.state.schoolId,
        securityTeamName: "", //小组名称
        teamMemberList: [], //组长
        teamLeaderList: [], //后勤人员  teamLeaderResponsibilities维修范围 userId维修人id
        teamReporters: [] //组员  userId组员id
      }
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  methods: {
    isDeleteChoice(data) {
      if (data.whetherHiddenGroup == 1) {
        return false;
      } else {
        return true;
      }
    },
    searchData() {
      this.getDataList();
    },
    // 打开新增
    openAddBox() {
      this.type = "add";
      this.addOrEditBox = true;
      this.addOrEditId = "";
      this.defaultData = {
        schoolId: this.$store.state.schoolId,
        securityTeamName: "", //小组名称
        teamMemberList: [], //组长
        teamLeaderList: [], //后勤人员  teamLeaderResponsibilities维修范围 userId维修人id
        teamReporters: [] //组员  userId组员id
      };
    },
    // 返回或关闭
    goBack() {
      this.addOrEditBox = false;
      this.addOrEditId = "";
      this.getDataList();
    },
    // 打开编辑
    openEditBox(row) {
      this.type = "edit";
      this.addOrEditBox = true;
      this.addOrEditId = row.securityTeamId + "" || "";
      this.defaultData.securityTeamId = row.securityTeamId;
      this.defaultData.securityTeamName = row.securityTeamName;
      let oneData = row.rearServicePersonnel || [];
      this.defaultData.teamLeaderList = oneData.map((item) => {
        let obj = {
          teamLeaderResponsibilities: item.teamLeaderResponsibilities,
          userId: item.userId,
          userName: item.userName
        };
        return obj;
      });

      let twoData = row.groupLeader || [];
      this.defaultData.teamMemberList = twoData.map((item) => {
        let obj = {
          userId: item.userId,
          userName: item.userName,
          teamMemberResponsibilities: item.teamMemberResponsibilities
        };
        return obj;
      });
    },

    // 删除安全小组数据
    deleteListData(thisId = 0) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            securityTeamId: [thisId]
          };
          let res = await this.$Http.delSecurityTeam(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 获取安全小组数据列表
    async getDataList() {
      var newParamsData = Object.assign({}, this.requestParamsData);
      if (newParamsData.securityTeamName == "") {
        delete newParamsData.securityTeamName;
      }
      let res = await this.$Http.getSecurityGroupList(newParamsData);
      if (res.code == 200) {
        this.formData = res.data || {};
        let oneArr = this.formData.groupLeader.map((item) => {
          let teamMemberResponsibilities = item.teamMemberResponsibilities;
          return teamMemberResponsibilities == "" ? item.userName || "" : item.userName + "(职责：" + item.teamMemberResponsibilities + ")";
        });
        this.formData.groupLeaderStr = oneArr.join(",");
        let twoArr = this.formData.rearServicePersonnel.map((item) => {
          return (
            item.userName + "(职责：" + item.teamLeaderResponsibilities + ")" ||
            ""
          );
        });
        this.formData.rearServicePersonnelStr = twoArr.join(",");
        let threeArr = this.formData.groupMember.map((item) => {
          return item.userName || "";
        });
        this.formData.groupMemberStr = threeArr.join(",");
      } else if (res.code == 101) {
        this.formData = {};
      } else {
        this.formData = {};
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>

<style scoped lang="scss">
.content-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .info-content {
    width: 70%;
    min-height: 400px;
    padding: 30px;
    background: url("~@/assets/img/schoolSafetyReport/content-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
  }
}
</style>
